import React, { useContext, Fragment } from "react";
import AuthContext from "../../context/auth/authContext";
import "../../styles/fonts.css";
const Alert = () => {
  const authContext = useContext(AuthContext);
  const { errors, removeErrors } = authContext;
  return (
    <Fragment>
      {errors && errors !== "The email address is badly formatted." && (
        <div
          className='alert alert-warning alert-dismissible fade show fontcool'
          role='alert'
        >
          {errors}
          <button
            type='button'
            className='close slantfont'
            data-dismiss='alert'
            aria-label='Close'
            onClick={removeErrors}
          >
            <span aria-hidden='true'>&times;</span>
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default Alert;
